/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Target_Business_CentralInputs */

const en_sync_target_business_central = /** @type {(inputs: Sync_Target_Business_CentralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Central`)
};

/**
* | output |
* | --- |
* | "Business Central" |
*
* @param {Sync_Target_Business_CentralInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_target_business_central = /** @type {((inputs?: Sync_Target_Business_CentralInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Target_Business_CentralInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_target_business_central(inputs)
});